/*
 * This code is the intellectual property of Bulb Inc. and other software publishers.
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { Component, Input } from '@angular/core';

import { faTrashAltIcon } from 'IconLibrary/fontawesome/regular/trash-alt';
import { SvgIconRegistry } from '@ngneat/svg-icon';
import { MenuItem } from '../../menus/types';

/*
 * This is the component for ellipse menu dropdown on tiles view.
*/
@Component({
  selector: 'bulb-tiles-triple-dot',
  templateUrl: './tiles-triple-dot.component.html',
  styleUrls: ['./tiles-triple-dot.component.scss'],
  standalone: false,
})
export class TilesTripleDotComponent {
  @Input() unit : any;

  @Input() menuItems : Array<MenuItem>;

  @Input() canEdit: boolean;

  constructor(private iconRegistry: SvgIconRegistry) {
    this.iconRegistry.register([faTrashAltIcon]);
  }
}
